<template>
  <div class="category">
    <Header class="category__header" @change="changeTab" />

    <!-- TODO: 异常页面 -->
    <main class="category__main">
      <a-list
        :pagination="pagination"
        :grid="{ gutter: 16, xs: 1, sm: 2, md: 2, lg: 3, xl: 4, xxl: 6 }"
        :data-source="categorys"
        :locale="{
          emptyText: showActive
            ? '暂无分类，点击页面右上角添加分类吧'
            : '没有归档的分类'
        }"
      >
        <a-list-item slot="renderItem" slot-scope="item">
          <CategoryCard :category="item" />
        </a-list-item>
      </a-list>
    </main>
  </div>
</template>

<script>
import Header from "./components/CategoryHeader";
import CategoryCard from "./components/CategoryCard";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      showActive: true,
      pagination: {
        pageSize: 24,
        hideOnSinglePage: true
      }
    };
  },
  components: {
    Header,
    CategoryCard
  },
  methods: {
    changeTab(activeKey) {
      this.showActive = activeKey === "active" ? true : false;
    },
    ...mapActions(["createCategory"])
  },
  computed: {
    categorys() {
      const result = [];
      const categorys = this.$store.getters.categorys;

      for (const i in categorys) {
        if (categorys[i].active === this.showActive) {
          result.push(categorys[i]);
        }
      }
      return result;
    }
    // ...mapGetters(["categorys"])
  }
};
</script>

<style>
.category__main {
  padding: 20px;
}
</style>
